import { PiCopy } from 'react-icons/pi'

import { useCopyToClipboard } from '@uidotdev/usehooks'
import Prism from 'prismjs'

// Import the specific language syntax you need
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-typescript'
import 'prismjs/components/prism-yaml'
import 'prismjs/themes/prism.min.css'

import { useEffect, useRef, useState } from 'react'

type CodeBlockProps = {
  code: string
  language?: 'yaml' | 'typescript' | 'bash'
}

export const CodeBlock = ({ code, language = 'yaml' }: CodeBlockProps) => {
  const [, copy] = useCopyToClipboard()
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const onCopy = () => {
    copy(code.trim())
    setCopied(true)
    timeoutRef.current = setTimeout(() => {
      setCopied(false)
    }, 3000)
  }

  useEffect(() => {
    Prism.highlightAll()

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  return (
    <div className="my-2 flex flex-col gap-2">
      <div className="flex justify-end text-sm text-gray-800">
        <div className="flex gap-2">
          {copied && <div>Copied</div>}
          <PiCopy className="h-6 w-6 cursor-pointer text-gray-900" onClick={onCopy} />
        </div>
      </div>
      <pre className="rounded-lg bg-gray-50 p-4">
        <code className={`language-${language}`}>{code.trim()}</code>
      </pre>
    </div>
  )
}
